import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { JBDateInput } from "jb-date-input-react";

// JS Files
import Navbar from "../../../shares/Navbar";
import Footer from "../../../shares/Footer";
import MuiTheme from "../../../shares/MuiTheme";
import MuiTextFieldHook from "../../../shares/MuiTextFieldHook";
import MuiSelectHook from "../../../shares/MuiSelectHook";
import MuiDateField from "../../../shares/MuiDateField";
import { TreatmentProvince } from "../../../../TreatmentProvince";
import MuiButton from "../../../shares/MuiButton";
import { useUserData } from "../../../../context/UserDataContext";
import useFetch from "../../../../context/useFetch";
import successImg from "../../../../imgs/success.svg";


// Others File

const genderList = [
  {
    name: "مرد",
    value: "male",
  },

  {
    name: "زن",
    value: "female",
  },
];
const marringeList = [
  {
    name: "متاهل",
    value: "is_married",
  },

  {
    name: "مجرد",
    value: "single",
  },
];
const insuranceList = [
  {
    name: "تامین اجتماعی",
    value: "tamin",
  },

  {
    name: "خدمات درمانی (بیمه سلامت)",
    value: "khadamat",
  },
  {
    name: "سایر",
    value: "other",
  },
];
const StepOne = () => {
  const navigate = useNavigate();
  const { userData } = useUserData();
  const {
    watch,
    handleSubmit,
    control,
    formState: { errors },
    reset,
    setValue,
  } = useForm({
    defaultValues: {
      name: "",
      gender: "",
      code: "",
      father_name: "",
      birth_provience: "",
      birth_city: "",
      identity_num: "",
      identify_provience: "",
      identify_city: "",
      marrige: "",
      children_num: 0,
      personal_code: "",
      insurance: "",
      service_provience: "",
      service_city: "",
      service_zone: "",
      shaba_num: "",
    },
  });

  const [treatmentRequestId, setTreatmentRequestId] = useState(0);
  const [treatmentRequestMainInsuredId, setTreatmentRequestMainInsuredId] =
    useState();
  const [postData, setPostData] = useState();
  const [birthDate, setBirthDate] = useState(undefined);

  const [status, setStatus] = useState(false);
  const GetUserTreatmentRequestCheckStatusServiceApi = useFetch({
    url: `User_Service/${userData.username}/check_treatment_request_status_step_one`,
    method: "GET",
    trigger: true,
    argFunc: (res) => {
      if (res.status) {
        setStatus(res.status);
      }
    },
    errMessage: (res) => {},
  });
  
  const GetUserTreatmentRequestServiceApi = useFetch({
    url: `User_Service/${userData.username}/user_get_treatment_request_info`,
    method: "GET",
    trigger: true,
    argFunc: (res) => {
      if (res.status) {
        setTreatmentRequestId(
          res.data.treatment_request_main_insured[0].treatment_request
        );
        setTreatmentRequestMainInsuredId(
          res.data.treatment_request_main_insured[0].id
        );
        setBirthDate(
          new Date(res.data.treatment_request_main_insured[0].birth_date)
        );
        setValue("name", res.data.treatment_request_main_insured[0].name);
        setValue("gender", res.data.treatment_request_main_insured[0].gender);
        setValue("code", res.data.treatment_request_main_insured[0].code);
        setValue(
          "father_name",
          res.data.treatment_request_main_insured[0].father_name
        );
        setValue(
          "birth_provience",
          res.data.treatment_request_main_insured[0].birth_provience
        );
        setValue(
          "birth_city",
          res.data.treatment_request_main_insured[0].birth_city
        );
        setValue(
          "identity_num",
          res.data.treatment_request_main_insured[0].identity_num
        );
        setValue(
          "identify_provience",
          res.data.treatment_request_main_insured[0].identify_provience
        );
        setValue(
          "identify_city",
          res.data.treatment_request_main_insured[0].identify_city
        );
        setValue("marrige", res.data.treatment_request_main_insured[0].marrige);
        setValue(
          "children_num",
          res.data.treatment_request_main_insured[0].children_num
        );
        setValue(
          "personal_code",
          res.data.treatment_request_main_insured[0].personal_code
        );
        setValue(
          "insurance",
          res.data.treatment_request_main_insured[0].insurance
        );
        setValue(
          "service_provience",
          res.data.treatment_request_main_insured[0].service_provience
        );
        setValue(
          "service_city",
          res.data.treatment_request_main_insured[0].service_city
        );
        setValue(
          "service_zone",
          res.data.treatment_request_main_insured[0].service_zone.id
        );
        setValue(
          "shaba_num",
          res.data.treatment_request_main_insured[0].shaba_num
        );
        getZones.reFetch();
      }
    },
    errMessage: (res) => {},
  });

  const TreatmentRequestServiceApi = useFetch({
    url: `TreatmentRequest_Service`,
    method: "POST",
    data: { user: userData.username },
    trigger: false,
    argFunc: (res) => {
      setTreatmentRequestId(res.id);
      let postDataCopy = { ...postData };
      postDataCopy["treatment_request"] = res.id;
      setPostData(postDataCopy);
      TreatmentRequestMainInsuredServiceApi.reFetch();
    },
    errMessage: (res) => {},
  });
  const [zones, setZones] = useState([]);
  const getZones = useFetch({
    url: `Zone_Service/get_zones_using_province`,
    method: "POST",
    data: { province: watch("service_provience"), city: watch("service_city") },
    trigger: false,
    argFunc: (res) => {
      setZones(res);
    },
    errMessage: (res) => {},
  });

  useEffect(() => {
    getZones.reFetch();
  }, [watch("service_city")]);

  const TreatmentRequestMainInsuredServiceApi = useFetch({
    url: `TreatmentRequestMainInsured_Service`,
    method: "POST",
    data: postData,
    trigger: false,
    argFunc: (res) => {
      if (res.data == "done")
        navigate("/step-two", {
          state: {
            treatmentRequestMainInsuredId: res.id,
            treatmentRequestId: treatmentRequestId,
          },
        });
    },
    errMessage: (res) => {},
  });

  const UpdateTreatmentRequestMainInsuredServiceApi = useFetch({
    url: `TreatmentRequestMainInsured_Service/${treatmentRequestMainInsuredId}`,
    method: "PATCH",
    data: postData,
    trigger: false,
    argFunc: (res) => {
      navigate("/step-two", {
        state: {
          treatmentRequestMainInsuredId: treatmentRequestMainInsuredId,
          treatmentRequestId: treatmentRequestId,
        },
      });
    },
    errMessage: (res) => {},
  });

  const onSubmit = (data) => {
    if (treatmentRequestId !== 0) {
      let d = { ...data };

      d["birth_date"] = dayjs(birthDate).format("YYYY-MM-DD");
      d["service_fa_provience"] = TreatmentProvince.filter(
        (it) => it.value == data["service_provience"]
      )[0].name;
      setPostData(d);
      UpdateTreatmentRequestMainInsuredServiceApi.reFetch();
    } else {
      let d = { ...data };
      if (d["marrige"] == "single") d["children_num"] = 0;
      d["birth_date"] = dayjs(birthDate).format("YYYY-MM-DD");
      d["mobile"] = userData.username;
      d["service_fa_provience"] = TreatmentProvince.filter(
        (it) => it.value == data["service_provience"]
      )[0].name;
      setPostData(d);
      TreatmentRequestServiceApi.reFetch();
    }
  };
  

  return (
    <>
      <div className="hp-section-one">
        <Navbar activePage="aboutus" />
      </div>

      {!GetUserTreatmentRequestCheckStatusServiceApi.loading && (
        <>
          {status ? (
            <div className="mt-10 md:mt-12 mx-4 md:mx-16 mb-2">
              <p className="header">ثبت‌نام بیمه درمان تکمیلی</p>
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="border rounded-lg mt-8 border-mygray-300 py-4 md:py-8 px-4">
                  <div className="border-r-4 border-mygray-300 px-4">
                    <span className="text-sm md:text-base font-bold text-mygray-700">
                      اطلاعات فردی
                    </span>
                  </div>
                  <div className="grid md:grid-cols-4 gap-4 mt-8 mx-4 md:mx-12">
                    <MuiTheme>
                      <MuiTextFieldHook
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        label="نام و نام‌خانوادگی"
                        name="name"
                        control={control}
                        register={{
                          required: {
                            value: true,
                            message: "نام و نام خانوادگی را وارد کنید",
                          },
                        }}
                      />
                      <MuiSelectHook
                        size="small"
                        inputLabel="جنسیت"
                        label="gender"
                        control={control}
                        name="gender"
                        register={{
                          required: {
                            value: true,
                            message: "جنسیت را انتخاب کنید",
                          },
                        }}
                        labelId="gender-label"
                        id="gender-select"
                        menuItems={genderList}
                        fromApi={false}
                      />
                      <MuiTextFieldHook
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        label="کد ملی"
                        name="code"
                        control={control}
                        isLTR
                        register={{
                          required: {
                            value: true,
                            message: "کدملی را وارد کنید",
                          },
                          pattern: {
                            value: /^[0-9]{10}$/,
                            message: "کدملی باید ۱۰ رقم باشد."
                          }
                        }}
                        type="number"
                      />
                      <MuiTextFieldHook
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        label="نام پدر"
                        name="father_name"
                        control={control}
                        register={{
                          required: {
                            value: true,
                            message: "نام پدر را وارد کنید",
                          },
                        }}
                      />

                      <JBDateInput
                        value={birthDate}
                        onChange={(event) => {
                          setBirthDate(event.target.value);
                        }}
                      ></JBDateInput>

                      {/* <MuiDateField
                  value={birthDate}
                  label="تاریخ تولد"
                  onChange={(date) => {
                    setBirthDate(date);
                  }}
                /> */}
                      <MuiSelectHook
                        size="small"
                        inputLabel="استان محل تولد"
                        label="birth_provience"
                        control={control}
                        name="birth_provience"
                        register={{
                          required: {
                            value: true,
                            message: "استان محل تولد را انتخاب کنید",
                          },
                        }}
                        labelId="birth_provience-label"
                        id="birth_provience-select"
                        menuItems={TreatmentProvince.map((it) => {
                          return { name: it.name, value: it.value };
                        })}
                        fromApi={false}
                      />
                      <MuiSelectHook
                        size="small"
                        inputLabel="شهر محل تولد"
                        label="birth_city"
                        control={control}
                        name="birth_city"
                        register={{
                          required: {
                            value: true,
                            message: "شهر محل تولد را انتخاب کنید",
                          },
                        }}
                        labelId="birth_city-label"
                        id="birth_city-select"
                        menuItems={
                          watch("birth_provience") !== undefined &&
                          watch("birth_provience") !== ""
                            ? TreatmentProvince.filter(
                                (it) => it.value == watch("birth_provience")
                              )[0].cities.map((ci) => {
                                return {
                                  name: ci,
                                  value: ci,
                                };
                              })
                            : []
                        }
                        fromApi={false}
                      />
                      <MuiTextFieldHook
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        label="شماره شناسنامه"
                        name="identity_num"
                        control={control}
                        isLTR
                        register={{
                          required: {
                            value: true,
                            message: "شماره شناسنامه را وارد کنید",
                          },
                        }}
                        type="number"
                      />
                      <MuiSelectHook
                        size="small"
                        inputLabel="استان محل صدور"
                        label="identify_provience"
                        control={control}
                        name="identify_provience"
                        register={{
                          required: {
                            value: true,
                            message: "استان محل صدور را انتخاب کنید",
                          },
                        }}
                        labelId="identify_provience-label"
                        id="identify_provience-select"
                        menuItems={TreatmentProvince.map((it) => {
                          return { name: it.name, value: it.value };
                        })}
                        fromApi={false}
                      />
                      <MuiSelectHook
                        size="small"
                        inputLabel="شهر محل صدور"
                        label="identify_city"
                        control={control}
                        name="identify_city"
                        register={{
                          required: {
                            value: true,
                            message: "شهر محل صدور را انتخاب کنید",
                          },
                        }}
                        labelId="identify_city-label"
                        id="identify_city-select"
                        menuItems={
                          watch("identify_provience") !== undefined &&
                          watch("identify_provience") !== ""
                            ? TreatmentProvince.filter(
                                (it) => it.value == watch("identify_provience")
                              )[0].cities.map((ci) => {
                                return {
                                  name: ci,
                                  value: ci,
                                };
                              })
                            : []
                        }
                        fromApi={false}
                      />
                      <MuiSelectHook
                        size="small"
                        inputLabel="وضعیت تاهل"
                        label="marrige"
                        control={control}
                        name="marrige"
                        register={{
                          required: {
                            value: true,
                            message: "وضعیت تاهل را انتخاب کنید",
                          },
                        }}
                        labelId="marrige-label"
                        id="marrige-select"
                        menuItems={marringeList}
                        fromApi={false}
                      />
                      {watch("marrige") == "is_married" && (
                        <MuiTextFieldHook
                          id="outlined-basic"
                          variant="outlined"
                          size="small"
                          label="تعداد فرزندان اعلامی"
                          name="children_num"
                          control={control}
                          isLTR
                          register={{
                            required: {
                              value: true,
                              message: "تعداد فرزندان اعلامی را وارد کنید",
                            },
                          }}
                          type="number"
                        />
                      )}
                    </MuiTheme>
                  </div>
                  <div className="border-r-4 border-mygray-300 px-4 mt-12">
                    <span className="text-sm md:text-base font-bold text-mygray-700">
                      اطلاعات مربوط به خدمت
                    </span>
                  </div>
                  <div className="grid md:grid-cols-4 gap-4 mt-8 mx-4 md:mx-12">
                    <MuiTheme>
                      <MuiTextFieldHook
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        label="کد پرسنلی"
                        name="personal_code"
                        control={control}
                        isLTR
                        register={{
                          required: {
                            value: true,
                            message: "کد پرسنلی را وارد کنید",
                          },
                        }}
                      />
                      <MuiSelectHook
                        size="small"
                        inputLabel="بیمه‌گر پایه"
                        label="insurance"
                        control={control}
                        name="insurance"
                        register={{
                          required: {
                            value: true,
                            message: "بیمه‌گر پایه را انتخاب کنید",
                          },
                        }}
                        labelId="insurance-label"
                        id="insurance-select"
                        menuItems={insuranceList}
                        fromApi={false}
                      />
                      <MuiSelectHook
                        size="small"
                        inputLabel="استان محل خدمت"
                        label="service_provience"
                        control={control}
                        name="service_provience"
                        register={{
                          required: {
                            value: true,
                            message: "استان محل خدمت را انتخاب کنید",
                          },
                        }}
                        labelId="service_provience-label"
                        id="service_provience-select"
                        menuItems={TreatmentProvince.map((it) => {
                          return { name: it.name, value: it.value };
                        })}
                        fromApi={false}
                      />
                      <MuiSelectHook
                        size="small"
                        inputLabel="شهر محل خدمت"
                        label="service_city"
                        control={control}
                        name="service_city"
                        register={{
                          required: {
                            value: true,
                            message: "شهر محل صدور را انتخاب کنید",
                          },
                        }}
                        labelId="service_city-label"
                        id="service_city-select"
                        menuItems={
                          watch("service_provience") !== undefined &&
                          watch("service_provience") !== ""
                            ? TreatmentProvince.filter(
                                (it) => it.value == watch("service_provience")
                              )[0].cities.map((ci) => {
                                return {
                                  name: ci,
                                  value: ci,
                                };
                              })
                            : []
                        }
                        fromApi={false}
                      />
                      <MuiSelectHook
                        size="small"
                        inputLabel="منطقه محل خدمت"
                        label="service_zone"
                        control={control}
                        name="service_zone"
                        register={{
                          required: {
                            value: true,
                            message: "منطقه محل صدور را انتخاب کنید",
                          },
                        }}
                        labelId="service_zone-label"
                        id="service_zone-select"
                        menuItems={zones}
                        fromApi={true}
                        // defaultValue={watch('service_zone')}
                      />
                      <MuiTextFieldHook
                        id="outlined-basic"
                        variant="outlined"
                        size="small"
                        label="IR شماره شبا بدون"
                        name="shaba_num"
                        control={control}
                        isLTR
                        register={{
                          required: {
                            value: true,
                            message: "شماره شبا را وارد کنید",
                          },
                        }}
                        type="number"
                      />
                    </MuiTheme>
                  </div>
                </div>
                <div className="text-left mt-8 flex justify-between items-center">
                  <MuiButton
                    onClick={() => navigate(-1)}
                    type="submit"
                    variant="outlined"
                    color="primary"
                    text="بازگشت"
                  />
                  <MuiButton
                    type="submit"
                    variant="contained"
                    color="primary"
                    text="تایید و ادامه"
                    disabled={
                      birthDate == undefined ||
                      UpdateTreatmentRequestMainInsuredServiceApi.loading ||
                      TreatmentRequestMainInsuredServiceApi.loading ||
                      TreatmentRequestServiceApi.loading
                    }
                  />
                </div>
              </form>
            </div>
          ) : (
            <div className="mt-10 md:mt-12 mx-4 md:mx-16 mb-2">
            <p className="header">ثبت‌نام بیمه درمان تکمیلی</p>
            <div className="border rounded-lg mt-8 border-mygray-300 py-4 md:py-8 px-4 flex flex-col w-full justify-center items-center">
              <img className="md:w-24 md:h-24" src={successImg}/>
              <p className="text-sm leading-8 text-mygray-500 mt-6 md:mt-12">
               درخواست ثبت‌نام بیمه درمان تکمیلی برای شما و افراد تحت تکفل وارده مورد تایید قرار گرفته است.
              </p>
             
            </div>
          </div>
          )}
        </>
      )}

      <Footer />
    </>
  );
};
export default StepOne;
